<template>
  <div class="cloud-signature-container">
    <div class="signature-card">
      <div class="card-header">
        <div class="header-icon">
          <i class="fas fa-cloud-upload-alt"></i>
        </div>
        <p class="card-subtitle">Certificado em Nuvem</p>
      </div>

      <div class="card-content">
        <div class="signature-info">
          <div class="info-item">
            <i class="fas fa-shield-alt info-icon"></i>
            <span class="info-text">Assinatura segura e certificada</span>
          </div>
          <div class="info-item">
            <i class="fas fa-clock info-icon"></i>
            <span class="info-text">Processo rápido e automatizado</span>
          </div>
          <div class="info-item">
            <i class="fas fa-check-circle info-icon"></i>
            <span class="info-text">Validade jurídica garantida</span>
          </div>
        </div>

        <div class="signature-action">
          <v-btn
            class="btn-sign-cloud"
            @click="execute"
            :disabled="loading"
            :loading="loading"
            large
          >
            <i class="fas fa-signature btn-icon"></i>
            {{
              loading ? "Processando..." : "Assinar com Certificado em Nuvem"
            }}
          </v-btn>
        </div>

        <!-- Message Display -->
        <div v-if="message" class="message-container">
          <div class="message-content">
            <i class="fas fa-info-circle message-icon"></i>
            <span class="message-text">{{ message }}</span>
          </div>
        </div>

        <!-- Error Display -->
        <div v-if="errors.length > 0" class="errors-container">
          <div v-for="(error, index) in errors" :key="index" class="error-item">
            <i class="fas fa-exclamation-triangle error-icon"></i>
            <span class="error-text">{{ error.message || error }}</span>
          </div>
        </div>

        <!-- Loading State -->
        <div v-if="loading" class="loading-overlay">
          <div class="loading-content">
            <div class="loading-spinner">
              <i class="fas fa-certificate fa-spin"></i>
            </div>
            <p class="loading-text">Redirecionando para autenticação...</p>
            <div class="loading-steps">
              <div class="step active">
                <span class="step-number">1</span>
                <span class="step-text">Iniciando processo</span>
              </div>
              <div class="step">
                <span class="step-number">2</span>
                <span class="step-text">Autenticação externa</span>
              </div>
              <div class="step">
                <span class="step-number">3</span>
                <span class="step-text">Conclusão</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../../../services/api";

export default {
  name: "BRyHUBSignCloud",

  data() {
    return {
      loading: false,
      message: null,
      code_verifier: null,
      code_challenge: null,
      errors: [],
    };
  },

  methods: {
    async execute() {
      try {
        this.loading = true;
        this.errors = [];
        this.message = null;

        const response = await api.post("/bry/user/sign-cloud");

        let { error, errors, authorize_url, code_verifier, code_challenge } =
          response.data;

        if (error) {
          this.errors = errors;
          this.loading = false;
          return;
        } else {
          this.code_verifier = code_verifier;
          this.code_challenge = code_challenge;

          // Simular delay para mostrar loading
          setTimeout(() => {
            window.open(authorize_url, "_blank");
            this.loading = false;
            this.message =
              "Janela de autenticação aberta. Complete o processo na nova aba.";
          }, 1500);
        }
      } catch (error) {
        this.loading = false;
        this.errors = [
          { message: "Erro ao conectar com o serviço de assinatura" },
        ];
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.cloud-signature-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  padding: 24px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.signature-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
  max-width: 500px;
  width: 100%;
  position: relative;
}

/* Card Header */
.card-header {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  color: white;
  padding: 32px 24px;
  text-align: center;
  position: relative;
}

.header-icon {
  width: 64px;
  height: 64px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px auto;
  font-size: 24px;
}

.card-title {
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 8px 0;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.card-subtitle {
  font-size: 16px;
  margin: 0;
  opacity: 0.9;
  font-weight: 500;
}

/* Card Content */
.card-content {
  padding: 32px 24px;
  position: relative;
}

/* Signature Info */
.signature-info {
  margin-bottom: 32px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #f8fafc;
  border-radius: 12px;
  margin-bottom: 12px;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
}

.info-item:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
  transform: translateX(4px);
}

.info-icon {
  color: #0f65b0;
  font-size: 16px;
  width: 20px;
  text-align: center;
}

.info-text {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

/* Signature Action */
.signature-action {
  text-align: center;
  margin-bottom: 24px;
}

.btn-sign-cloud {
  background: linear-gradient(135deg, #4e9130 0%, #1e884d 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 16px 32px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 16px !important;
  box-shadow: 0 6px 20px rgba(78, 145, 48, 0.3) !important;
  transition: all 0.3s ease !important;
  min-width: 280px !important;
  height: 56px !important;
}

.btn-sign-cloud:hover:not(:disabled) {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(78, 145, 48, 0.4) !important;
}

.btn-sign-cloud:disabled {
  opacity: 0.8 !important;
  cursor: not-allowed !important;
  transform: none !important;
}

.btn-icon {
  margin-right: 8px;
  font-size: 18px;
}

/* Message Container */
.message-container {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  border: 1px solid #60a5fa;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
}

.message-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.message-icon {
  color: #2563eb;
  font-size: 16px;
}

.message-text {
  color: #1e40af;
  font-size: 14px;
  font-weight: 500;
}

/* Error Container */
.errors-container {
  margin-bottom: 16px;
}

.error-item {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 1px solid #fca5a5;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.error-icon {
  color: #dc2626;
  font-size: 16px;
}

.error-text {
  color: #991b1b;
  font-size: 14px;
  font-weight: 500;
}

/* Loading Overlay */
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0 0 20px 20px;
}

.loading-content {
  text-align: center;
  padding: 32px;
}

.loading-spinner {
  margin-bottom: 20px;
}

.loading-spinner i {
  font-size: 48px;
  color: #0f65b0;
}

.loading-text {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 24px 0;
}

/* Loading Steps */
.loading-steps {
  display: flex;
  justify-content: center;
  gap: 24px;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  opacity: 0.5;
  transition: all 0.3s ease;
}

.step.active {
  opacity: 1;
}

.step-number {
  width: 32px;
  height: 32px;
  background: #e5e7eb;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.step.active .step-number {
  background: #0f65b0;
  color: white;
}

.step-text {
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  text-align: center;
}

.step.active .step-text {
  color: #374151;
  font-weight: 600;
}

/* Responsive Design */
@media (max-width: 768px) {
  .cloud-signature-container {
    padding: 16px;
    min-height: 300px;
  }

  .signature-card {
    border-radius: 16px;
  }

  .card-header {
    padding: 24px 20px;
  }

  .header-icon {
    width: 56px;
    height: 56px;
    font-size: 20px;
  }

  .card-title {
    font-size: 20px;
  }

  .card-subtitle {
    font-size: 14px;
  }

  .card-content {
    padding: 24px 20px;
  }

  .btn-sign-cloud {
    min-width: 100% !important;
    font-size: 14px !important;
    padding: 14px 24px !important;
    height: 50px !important;
  }

  .loading-steps {
    flex-direction: column;
    gap: 16px;
  }

  .step {
    flex-direction: row;
    gap: 12px;
  }

  .step-number {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .info-item {
    padding: 10px 12px;
  }

  .info-text {
    font-size: 13px;
  }

  .message-text,
  .error-text {
    font-size: 13px;
  }

  .loading-content {
    padding: 24px 16px;
  }

  .loading-spinner i {
    font-size: 40px;
  }

  .loading-text {
    font-size: 14px;
  }
}

/* Animation para o ícone de loading */
@keyframes pulse-glow {
  0% {
    box-shadow: 0 0 0 0 rgba(15, 101, 176, 0.4);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(15, 101, 176, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(15, 101, 176, 0);
  }
}

.loading-spinner i {
  animation: pulse-glow 2s infinite;
}

/* Hover effects */
.signature-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}
</style>